import { render } from "./LoginScreen.vue?vue&type=template&id=05e20168&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=05e20168&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e20168"]])

export default __exports__